import { RouteConfig } from "../../types/RouteConfig";
import { postAdvertRoute } from "./post-advert/route";
import { myAdvertsRoute } from "./my-adverts/route";

export const advertsRoutes: RouteConfig<'with-children'> = {
    name: 'Adverts',
    icon: 'mdi mdi-tag-outline',
    context: 'member',
    children: [postAdvertRoute, myAdvertsRoute],
}
